/**
 * Safely normalize the status history into an array.
 *
 * Accepts:
 * - an array (already normalized)
 * - a JSON string representing an array
 * - null/undefined/empty string
 *
 * Returns:
 * - a status history array, or [] if missing/invalid
 */
export const normalizeStatusHistory = (statusHistory) => {
  if (Array.isArray(statusHistory)) return statusHistory;
  if (!statusHistory) return [];

  if (typeof statusHistory === 'string') {
    try {
      const parsed = JSON.parse(statusHistory);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  return [];
};
